export enum PayType {
  COMMISSION_BASED = 'COMMISSION_BASED',
  HOUR_BASED = 'HOUR_BASED',
}
